import { createEnum } from '@/libs/utils';

/** @enum {string} */
export const RouteName = createEnum(
  {
    Homepage: 'Homepage',
    Login: 'Login',
    Welcome: 'Welcome',
    Main: 'Main',
    NotFound: 'NotFound',
    Overview: 'Overview',
    Admin: 'Admin',
    AdminAccounts: 'AdminAccounts',
    AdminPermissions: 'AdminPermissions',
    AdminActionLog: 'AdminActionLog',
    AdminDataPermissions: 'AdminDataPermissions',
    Broadcaster: 'Broadcaster',
    BroadcasterRecruit: 'BroadcasterRecruit',
    BroadcasterRecruitList: 'BroadcasterRecruitList',
    BroadcasterRecruitProgress: 'BroadcasterRecruitProgress',
    BroadcasterAnchorInfoEdit: 'BroadcasterAnchorInfoEdit',
    BroadcasterList: 'BroadcasterList',
    BroadcasterRecheckList: 'BroadcasterRecheckList',
    BroadcasterListAll: 'BroadcasterListAll',
    BroadcasterListToBeRenewed: 'BroadcasterListToBeRenewed',
    BroadcasterListTerminated: 'BroadcasterListTerminated',
    BroadcasterListJoined: 'BroadcasterListJoined',
    BroadcasterLiveRealtime: 'BroadcasterLiveRealtime',
    BroadcasterModify: 'BroadcasterModify',
    Guild: 'Guild',
    GuildSecurity: 'GuildSecurity',
    GuildSecurityStatus: 'GuildSecurityStatus',
    GuildSecurityViolations: 'GuildSecurityViolations',
    GuildTeam: 'GuildTeam',
    DataCenter: 'DataCenter',
    LiveDataCoreMetrics: 'LiveDataCoreMetrics',
    LiveDataCoreMetricsSummary: 'LiveDataCoreMetricsSummary',
    LiveDataCoreMetricsIncome: 'LiveDataCoreMetricsIncome',
    LiveDataCoreMetricsLiveTimes: 'LiveDataCoreMetricsLiveTimes',
    LiveDataCoreMetricsNewFans: 'LiveDataCoreMetricsNewFans',
    DataCenterBroadcasterData: 'DataCenterBroadcasterData',
    DataCenterBroadcasterStats: 'DataCenterBroadcasterStats',
    DataCenterBroadcasterStatsDay: 'DataCenterBroadcasterStatsDay',
    DataCenterBroadcasterStatsMonth: 'DataCenterBroadcasterStatsMonth',
    DataCenterTeamData: 'DataCenterTeamData',
    LiveData: 'LiveData',
    LiveDataCore: 'LiveDataCore',
    LiveDataLive: 'LiveDataLive',
    LiveDataProxyLive: 'LiveDataProxyLive',
    LiveDataAnchor: 'LiveDataAnchor',
    LiveDataProxy: 'LiveDataProxy',
    LiveDataPK: 'LiveDataPK',
    LiveDataDetail: 'LiveDataDetail',
    LiveDataProxyDetail: 'LiveDataProxyDetail',
    LiveDataDesc: 'LiveDataDesc',
    Region: 'Region',
    RegionBroadcasterStats: 'RegionBroadcasterStats',
    RegionBroadcasterStatsDay: 'RegionBroadcasterStatsDay',
    RegionBroadcasterStatsMonth: 'RegionBroadcasterStatsMonth',
    RegionBroadcasterStatsAgencyData: 'RegionBroadcasterStatsAgencyData',
    Notification: 'Notification',
    Payment: 'Payment',
    PaymentDistributionUpload: 'PaymentDistributionUpload',
    PaymentDistributionAdjustment: 'PaymentDistributionAdjustment',
    PaymentTransfer: 'PaymentTransfer',
    PaymentBlacklist: 'PaymentBlacklist',
    PaymentActionLog: 'PaymentActionLog',
    PaymentBroadcasterPayment: 'PaymentBroadcasterPayment',
    PaymentBroadcasterPaymentByBeans: 'PaymentBroadcasterPaymentByBeans',
    PaymentBroadcasterPaymentActionLog: 'PaymentBroadcasterPaymentActionLog',
    PaymentAgencyPayment: 'PaymentAgencyPayment',
    PaymentAgencyPaymentByBeansWhitelist: 'PaymentAgencyPaymentByBeansWhitelist',
    PaymentAgencyPaymentByBeans: 'PaymentAgencyPaymentByBeans',
    PaymentAgencyPaymentBankInfo: 'PaymentAgencyPaymentBankInfo',
    PaymentAgencyPaymentActionLog: 'PaymentAgencyPaymentActionLog',
    PaymentByBeansMethod: 'PaymentByBeansMethod',
    Interview: 'Interview',
    InterviewList: 'InterviewList',
    ApplyNoPermission: 'ApplyNoPermission',
    ApplyForm: 'ApplyForm',
    ApplyProcess: 'ApplyProcess',
    AgentContact: 'AgentContact',
    AgentCertifyForm: 'AgentCertifyForm',
    BroadcasterLiveData: 'BroadcasterLiveData',
    BroadcasterListIndex: 'BroadcasterListIndex',
    LiveDataDetailAlias: 'LiveDataDetailAlias',
    LiveDataDescAlias: 'LiveDataDescAlias',
    BroadcasterModifyIndex: 'BroadcasterModifyIndex',
    BroadcasterOperate: 'BroadcasterOperate',
    AssignPkIndex: 'AssignPkIndex',
    AssignPkList: 'AssignPkList',
    SubAgentApplyList: 'SubAgentApplyList',
    SubAgentApplyProgress: 'SubAgentApplyProgress',
    SubAgentApplyProgressMobile: 'SubAgentApplyProgressMobile',
    ImDetermineRoute: 'ImDetermineRoute',
    ActRegist: 'ActRegist',
    ActRegistList: 'ActRegistList',
    ActDetail: 'ActDetail',
    ActRegistResult: 'ActRegistResult',
    ActRegistInfo: 'ActRegistInfo',
    ActRegistSchedule: 'ActRegistSchedule',
    RecommendHosts: 'RecommendHosts',
    NewBroadcasterData: 'NewBroadcasterData',
    NewBroadcasterManagerData: 'NewBroadcasterManagerData',
    NewBroadcasterAgentData: 'NewBroadcasterAgentData',
    NewBroadcasterDataDetail: 'NewBroadcasterDataDetail',
    AgencyAcademy: 'AgencyAcademy',
    AgencyAcademyList: 'AgencyAcademyList',
    AgencyAcademyDetail: 'AgencyAcademyDetail',
  },
  true,
);
